/*
 * PAWS & PEARLS — PEARL & ROSE-GOLD FLYING TOAD AUDIO V1
 * 28 October 2026 — ADDITIVE SOUND ONLY / MAGICAL MUSE WORLD duplicate theme.
 * One user-supplied, 18-second flutter + three quiet croaks mix.
 * This file NEVER changes the toad artwork, movement, V18 flight, other audio,
 * House sound controls, the Muse lookout, Lilla, hippo, birds, or pearls.
 *
 * To remove: DELETE ONLY this script tag from V18 Balloon Custom Liquid.
 */
(function () {
  'use strict';

  var NS = 'ppMuseFlyingToadAudioV1';
  var script = document.currentScript ||
    document.querySelector('script[data-pp-muse-flying-toad-audio-v1]');
  var soundURL = script && script.getAttribute('data-toad-audio-src');
  if (!soundURL || !/^(https?:\/\/|\/)/.test(soundURL)) return;
  if (window[NS] && window[NS].installed) return;

  // MADAM'S SOUND ADJUSTMENT DESK
  var PEAK_VOLUME = 0.20; // Deliberately gentle. 0.20 quieter; 0.45 louder. Never >1.
  var PRIME_VOLUME = 0.00001; // Near-silent Safari user-gesture audio primer.
  var CHECK_EVERY_MS = 95;
  var TRACK_DURATION_MS = 18000;

  var skyPageClass = 'pp-muse-secret-sky-page';
  var player = new Audio(soundURL);
  player.preload = 'auto';
  player.loop = false;
  player.volume = 0;
  player.setAttribute('playsinline','');
  player.setAttribute('aria-hidden','true');

  var timer = 0;
  var startedAtMs = 0;
  var audible = false;
  var primed = false;
  var run = 0;
  var currentRun = null;
  var lastError = '';

  function houseAllowsSound() {
    var house = window.ppHouseSound;
    if (!house || typeof house.isEnabled !== 'function') return false;
    try { return house.isEnabled() === true; }
    catch (err) { return false; }
  }
  function isSkyPage() {
    return document.documentElement.classList.contains(skyPageClass);
  }
  function toadStatus() {
    var toad = window.ppMuseFlyingToadV1;
    if (!toad || typeof toad.getStatus !== 'function') return null;
    try { return toad.getStatus(); }
    catch (err) { return null; }
  }
  function stop() {
    if (timer) clearInterval(timer);
    timer = 0;
    player.volume = 0;
    player.pause();
    player.loop = false;
    audible = false;
    primed = false;
    currentRun = null;
    run += 1;
  }
  function tick() {
    if (!currentRun) return;
    if (!isSkyPage() || !houseAllowsSound() || document.hidden) {
      stop(); return;
    }
    var state = toadStatus();
    if (!state || !state.running || state.atlasFailed) {
      stop(); return;
    }
    var elapsed = performance.now() - startedAtMs;
    var startMs = (state.appearingAfterSeconds || 26) * 1000;
    var durationMs = (state.appearanceDurationSeconds || 18) * 1000;
    var endMs = startMs + Math.min(durationMs, TRACK_DURATION_MS);
    if (elapsed >= endMs) { stop(); return; }
    if (elapsed < startMs || !state.atlasReady) {
      // Flight soundtrack must never start before the toad is actually drawable.
      player.volume = PRIME_VOLUME;
      return;
    }
    if (audible) return;
    if (!primed || player.readyState < 1) return;
    // The 18s mix was composed to match exactly the 18s visual appearance.
    // The audio has already been silently running since the balloon was clicked
    // to preserve Safari's user-gesture playback permission.
    try {
      player.currentTime = Math.max(0, Math.min(17.75, (elapsed-startMs)/1000));
      player.loop = false;
      player.volume = PEAK_VOLUME;
      audible = true;
    } catch (err) {
      lastError = String(err && err.message || err);
      player.volume = PRIME_VOLUME;
    }
  }
  function balloonClicked(event) {
    if (!isSkyPage() || document.hidden || !houseAllowsSound() || currentRun) return;
    var node = event.target && event.target.closest && event.target.closest(
      '#pp-muse-balloon-stage .pp-balloon, .pp-muse-flight-overlay.pp-balloon'
    );
    if (!node || !node.classList.contains('pp-muse-flight-overlay')) return;
    // This event is the visitor's *actual click* on the Muse balloon.
    // Prime this ONE player at an inaudible volume so Safari can later reveal
    // the sound without requesting a second gesture after the 26-second wait.
    var state = toadStatus();
    if (!state || !state.running) return;
    stop();
    var myRun = run;
    currentRun = {id:myRun};
    startedAtMs = performance.now();
    player.loop = true;
    player.volume = PRIME_VOLUME;
    try { player.currentTime = 0; }
    catch (err) { /* Metadata can arrive after the user's click. */ }
    try {
      var promise = player.play();
      if (promise && typeof promise.then === 'function') {
        promise.then(function () {
          if (currentRun && currentRun.id === myRun) primed = true;
        }, function (err) {
          if (currentRun && currentRun.id === myRun) {
            lastError = String(err && err.message || err);
            // Never make a surprise second autoplay attempt.
            stop();
            console.warn('[P&P Flying Toad Audio] Audio priming blocked:', lastError);
          }
        });
      } else {
        primed = true;
      }
    } catch (err) {
      lastError = String(err && err.message || err);
      stop(); return;
    }
    timer = setInterval(tick,CHECK_EVERY_MS);
  }
  function onHouseSoundChange() {
    // Sound OFF is absolute; restarting needs a new legitimate visitor click.
    if (!houseAllowsSound()) stop();
  }
  function onUnload(event) {
    var stage = document.getElementById('pp-muse-balloon-stage');
    if (stage && event.target && event.target.contains(stage)) stop();
  }

  document.addEventListener('click', balloonClicked, false);
  document.addEventListener('pp:house-sound-change', onHouseSoundChange);
  window.addEventListener('pp:house-sound-change', onHouseSoundChange);
  document.addEventListener('shopify:section:unload', onUnload);
  window.addEventListener('pagehide', stop);
  document.addEventListener('visibilitychange',function () {
    if (document.hidden) stop();
  });
  window[NS] = {
    installed:true,
    version:'1.0-one-mix-18s',
    getStatus:function () {
      return {running:!!currentRun, primed:primed, audible:audible,
        volume:PEAK_VOLUME, durationSeconds:18, hasOwnMuteButton:false,
        lastError:lastError, modifiesOtherHouseSystems:false};
    }
  };
})();
